// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fb","advertDetailParameterList__header":"c-q_fc","advertDetailParameterList__list":"c-q_fe"};